import { createFileRoute, useSearch  } from "@tanstack/react-router";
import { SuccessTransaction } from "@/components/wallet/TransactionStatuses/SuccessTransaction/SuccessTransaction";
import { z } from "zod";

const schema = z.object({
  token: z.string().optional(),
  signature: z.string().optional(),
  amount: z.string().optional(),
  asset: z.string().optional(),
  destination: z.string().optional(),
  fee: z.string().optional(),
  eta: z.string().optional(),
  key: z.string().optional(),


  dexFromMint: z.string().optional(),
  dexToMint: z.string().optional(),
  dexFromAsset: z.string().optional(),
  dexToAsset: z.string().optional(),

  zenexFromAsset: z.string().optional(),
  zenexToAsset: z.string().optional(),
  zenexFromAmount: z.string().optional(),
  zenexToAmount: z.string().optional(),
  zenexRate: z.string().optional(),

});

export const Route = createFileRoute("/_mainLayout/wallet/transaction-success/")({
  component: RouteComponent,
  validateSearch: schema
});

function RouteComponent() {
  const params = useSearch({ from: "/_mainLayout/wallet/transaction-success/" });
  return (
    <SuccessTransaction
      token={params.token}
      signature={params.signature}
      transactionKey={params.key}
      amount={params.amount}
      asset={params.asset}
      destination={params.destination}
      fee={params.fee}
      eta={params.eta}

      dexFromMint={params.dexFromMint}
      dexToMint={params.dexToMint}
      dexFromAsset={params.dexFromAsset}
      dexToAsset={params.dexToAsset}


      zenexFromAsset={params.zenexFromAsset}
    zenexToAsset={params.zenexToAsset}
    zenexFromAmount={params.zenexFromAmount}
    zenexToAmount={params.zenexToAmount}
    zenexRate={params.zenexRate}


    />
  );
}
